import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { PANTERA, BATTLESHIP, OLAF, OZ } from 'HubStyleTokens/colors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { highestProductLevelFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { getProductLevelFromApiNameString } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
const sharedTagStyles = css(["position:absolute;left:-1px;right:-1px;bottom:100%;font-size:0.625rem;padding-top:4px;padding-bottom:4px;border-top-left-radius:4px;border-top-right-radius:4px;"]);
const CurrentPlanTag = styled.div.withConfig({
  displayName: "FeatureTableColTag__CurrentPlanTag",
  componentId: "il0zlc-0"
})(["", " color:", ";background-color:", ";"], sharedTagStyles, PANTERA, BATTLESHIP);
const RecommendedPlanTag = styled.div.withConfig({
  displayName: "FeatureTableColTag__RecommendedPlanTag",
  componentId: "il0zlc-1"
})(["", " color:", ";background-color:", ";"], sharedTagStyles, OLAF, OZ);

const FeatureTableColTag = ({
  apiName,
  productLine,
  recommendedProductLevel,
  showRecommended = false
}) => {
  const columnProductLevel = getProductLevelFromApiNameString(apiName);
  const isAppAuth = useSelector(isAppAuthSelector);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isCurrentPlan = useSelector(state => hasPricingAndPurchasingSucceeded && highestProductLevelFromProductInventorySelector(state, {
    productLine
  }) === columnProductLevel && isAppAuth);
  if (isCurrentPlan) return /*#__PURE__*/_jsx(CurrentPlanTag, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "featureTable.planTags.currentPlan"
    })
  });
  if (showRecommended && columnProductLevel === recommendedProductLevel) return /*#__PURE__*/_jsx(RecommendedPlanTag, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "featureTable.planTags.recommendedPlan"
    })
  });
  return null;
};

export default FeatureTableColTag;